module.exports = __webpack_public_path__ + "img/2.a461c60f.png";